import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {addNFCtoStudent} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

function NFC({initialValues: studentDetails, onAfterSubmit}) {
  const submitHandler = (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')

    addNFCtoStudent({
      id: values.id,
      type: 'student',
      nfc_code: values.nfc_code,
    })
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        console.error(err)
        handleApiError(err, toastId)
      })
      .finally((res) => setLoading(false))
  }

  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={{
          id: studentDetails.student_id,
          student_name: studentDetails.student_name,
          nfc_code: studentDetails.nfc_code || '',
        }}
        validationSchema={Yup.object({
          nfc_code: Yup.string()
            .trim()
            .required('RFID is required')
            .notOneOf([''], 'RFID is required'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl control="input" label="Student Name" name="student_name" disabled />
            <FormikControl
              control="input"
              required
              placeholder="RFID"
              label="RFID"
              name="nfc_code"
            />
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default NFC
